import styled, { css } from "styled-components";
import {
  FieldTextInputCss,
  FieldTextLabelCss,
} from "../field-text/field-text.styles";

export const FieldDropdownListCss = css`
  background-color: #ffffff;
  border: 1px solid #e6e8f9;
  border-radius: 0.5rem;
  box-shadow: 0px 6px 8px 0px rgba(95, 99, 108, 0.12);
  left: 0;
  max-height: 180px;
  overflow: auto;
  padding: 0.125rem;
  position: absolute;
  top: calc(100% + 0.125rem);
  width: 100%;
  z-index: 999;
  .field-dropdown-items {
    display: flex;
    gap: 0.125rem;
    flex-direction: column;
  }
  .field-dropdown-item {
    align-items: center;
    border-radius: 0.375rem;
    cursor: pointer;
    display: flex;
    font-size: 0.875rem;
    min-height: 36px;
    overflow: hidden;
    padding: 0.5rem 1rem;
    white-space: nowrap;
    width: 100%;
    &.field-dropdown-item__active,
    &:hover {
      background-color: #e9e9ed;
    }
  }
`;

export const FieldDropdownContainerStyled = styled.div`
  position: relative;
`;

export const FieldDropdownInputStyled = styled.div`
  .sw-field-label {
    ${FieldTextLabelCss}
  }
  .sw-field-input {
    ${FieldTextInputCss}
    cursor: pointer;
    padding-right: 36px;
    position: relative;
    .value {
      color: #5f636c;
    }
    [class^="icon-"] {
      align-items: center;
      display: flex;
      height: 32px;
      justify-content: center;
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 36px;
      &::before {
        transition: all 0.4s;
      }
    }
  }
  &.field-dropdown__active {
    .sw-field-input {
      border-color: #262930;
      [class^="icon-"] {
        &::before {
          transform: rotate(180deg);
        }
      }
    }
  }
`;

export const FieldDropdownListStyled = styled.div`
  ${FieldDropdownListCss}
`;
